// Shared gate for the customer search inputs.
//
// The endpoint refuses a term under MIN_TERM_LENGTH characters, because a two
// or three character fragment matches most of a tenant - "817" is an area code,
// "Jo" is every Jones. One term is exempt: an exact customer id, which resolves
// to the single row it names. Mirrors CustomerSearchAndMatch.exact_id_in and
// MIN_TERM_LENGTH on the Rails side, so an input never withholds a term the
// endpoint would have answered.

export const MIN_TERM_LENGTH = 4;

const cleanTerm = (term: string): string => term.replace(/[()-]/g, "");

/**
 * Whether the term names a customer id: digits only, and no leading zero, so
 * "0048213" does not resolve to customer 48213.
 */
export const namesCustomerId = (term: string): boolean => {
  const trimmed = term.trim();
  if (!/^\d+$/.test(trimmed)) return false;

  return !(trimmed.length > 1 && trimmed.startsWith("0"));
};

/**
 * Whether the endpoint will answer this term. Length is the general rule; a
 * customer id is the exemption, which is what lets the 949 customers with an id
 * under four digits be found at all.
 */
export const isSearchableTerm = (term: string): boolean =>
  cleanTerm(term.trim()).length >= MIN_TERM_LENGTH || namesCustomerId(term);
